var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "ax-scopelessbar container" },
    [
      _c(
        "section",
        {
          staticClass: "ax-scopelessbar--top-bar",
          on: { mouseup: _vm.tryCloseSidebar }
        },
        [
          _c(
            "div",
            { staticClass: "ax-scopelessbar--top-bar__left-container" },
            [
              _c(
                "div",
                { staticClass: "ax-searchbar__logo-container" },
                [_c("ClassLogo")],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "ax-scopelessbar--top-bar__center-container"
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "rightContainer",
              staticClass: "ax-scopelessbar--top-bar__right-container"
            },
            [
              _c(
                "div",
                {
                  ref: "helpPanelButton",
                  staticClass: "ax-scopelessbar--icon-box",
                  class: { active: _vm.isHelpPanelOpen },
                  attrs: { id: "help-menu-toggle", title: "Help" },
                  on: { click: _vm.toggleHelp }
                },
                [_c("i", { staticClass: "ax-icon ax-icon--question" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "settingsButton",
                  staticClass: "ax-scopelessbar--icon-box",
                  class: { active: _vm.isSettingsPanelOpen },
                  attrs: { title: "My account", id: "setting-menu-toggle" },
                  on: { click: _vm.toggleSettings }
                },
                [_c("i", { staticClass: "ax-icon ax-icon--user-settings" })]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("settings-panel", {
        attrs: { username: _vm.username, "scopeless-mode": true }
      }),
      _vm._v(" "),
      _c("help-panel", { attrs: { "scopeless-mode": true } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }